import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ProductClassService} from 'app/blocks/service/api/product-class.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IProductClass} from 'app/blocks/model/product-class.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {ProductClass} from 'app/blocks/model/product-class.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class ProductClassResource extends AbstractEntityResource<IProductClass> {
    constructor(productClassService: ProductClassService, router: Router) {
        super(
            Resource.PRODUCT_CLASSES,
            productClassService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.PRODUCT_CLASSES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.PRODUCT_CLASSES),
            (entity?) => new ProductClass(entity),
            (entity) => entity.className,
            'group_work'
        );
    }
}
